import React from 'react';
import styles from './Modal.module.scss';
import { useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import { axiosBackend } from '../../../axios/Axios.js';
import "./Modal.css"
import { getToken } from "../../../services/auth";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs, { Dayjs } from 'dayjs';
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";
import axios from 'axios';
import { useSnackbar } from 'notistack';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

export default function ModalClient({handleReload, formData, setFormData , isOpen, onClose}) {
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()
  const MODAL_URL = "/clients";

  const config = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  };
  
  const handleSubmit = async () => {
    setLoading(true);
    const response = await axiosBackend.post(MODAL_URL, { ...formData, start: formData.start.unix() }, config).then((res) => {
      enqueueSnackbar('Cliente atualizado com sucesso!', { 
          variant: 'success'
        });
      setLoading(false);
      onClose();
      handleReload();
    }).catch((err) => {
      enqueueSnackbar('Falha ao atualizar cliente!', { 
          variant: 'error'
        })
      setLoading(false);
      onClose();
    });
  };

  return (
    <div className={`overlay ${isOpen ? 'open' : ''}`}>
      <Backdrop
      sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
      open={loading}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
      <div className={styles.draw_box}>
        <div className={styles.main_column}>
          <h1 className={styles.main_title}>Editar cliente</h1>
          <div className={styles.main_row}>
            <div className={styles.main_row_item} style={{width: "100%"}}>
              <label className={styles.field_title}>Nome do cliente</label>
              <input
                required
                className={styles.input_box_1}
                placeholder="Escreva o nome do cliente"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
              />
              <small className={styles.helper_text}>ex: ABC Company</small>
            </div>
          </div>
          <div className={styles.main_row}>
          <div className={styles.main_row_item}>
            <label className={styles.field_title}>Cliente desde</label>
            <div className={styles.shadow_div}>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
              <DatePicker
              required={true}
              maxDate={dayjs()}
              value={formData.start}
              format="DD/MM/YYYY"
              onChange={(newValue) =>  setFormData({ ...formData, start: newValue })}
              />
            </LocalizationProvider>
            </div>
          </div>
          <div className={styles.main_row_item}>
              <label className={styles.field_title}>Keyword</label>
              <input
                className={styles.input_box_1}
                placeholder="Escreva a chave do cliente"
                value={formData.key}
                onChange={(e) => setFormData({ ...formData, key: e.target.value })}
              />
              <small className={styles.helper_text}>ex: ABC</small>
            </div>
          </div>
          
          <div className={styles.main_row_item_2}>
              <label className={styles.field_title}>Escopo do cliente</label>
              <textarea
                className={styles.input_box_2}
                placeholder="Descreva o escopo do cliente"
                value={formData.escope}
                onChange={(e) => setFormData({ ...formData, escope: e.target.value })}
              />
          </div>

          <div className={styles.main_row}>
            <button className={styles.cancel_button} onClick={() => {
                onClose();
              }}
            >
              Cancelar
            </button>
            <button
              disabled={!formData.name || !formData.escope || !formData.key ? "disabled" : ""}
              className={styles.send_button}
              onClick={() => {
                handleSubmit();
              }}
            >
              Salvar
            </button>
          </div>
          
        </div>
      </div>
    </div>
  );
}